export default "__VITE_ASSET__CXmQJVTL__"